/*
  LZX Pesca — comportamentos do design system.

  Cobre o que o CSS sozinho não resolve: acordeão do FAQ, carrossel de
  diferenciais no celular, rotação da barra de anúncio e abertura dos menus.

  Escrito sem dependência e sem build: o Horizon carrega os assets direto,
  e um passo de compilação aqui só atrapalharia a sincronia com o GitHub.

  Tudo é delegado a partir do document e reinicializado no evento
  `shopify:section:load`, para continuar funcionando quando o lojista edita
  uma seção no editor de temas — o editor troca o HTML da seção sem recarregar
  a página, e listeners presos a elementos antigos morreriam.
*/

(function () {
  'use strict';

  var REDUCED_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* ---------------------------------------------------------------------
     Acordeão (FAQ)
     O painel é escondido por atributo `hidden` em vez de classe: assim ele
     também some da árvore de acessibilidade, e não só da tela.
     --------------------------------------------------------------------- */

  function toggleAccordion(summary) {
    var item = summary.closest('.lzx-accordion__item');
    if (!item) return;

    var panel = item.querySelector('.lzx-accordion__panel');
    var sign = summary.querySelector('.lzx-accordion__sign');
    var accordion = summary.closest('.lzx-accordion');
    var willOpen = summary.getAttribute('aria-expanded') !== 'true';

    summary.setAttribute('aria-expanded', String(willOpen));
    if (panel) panel.hidden = !willOpen;

    if (sign && accordion) {
      var url = accordion.dataset[willOpen ? 'iconMinus' : 'iconPlus'];
      if (url) {
        sign.style.maskImage = 'url(' + url + ')';
        sign.style.webkitMaskImage = 'url(' + url + ')';
      }
    }
  }

  document.addEventListener('click', function (event) {
    var summary = event.target.closest('.lzx-accordion__summary');
    if (summary) toggleAccordion(summary);
  });

  /* ---------------------------------------------------------------------
     Carrossel de diferenciais (celular)
     No desktop os quatro itens aparecem em grade e as setas ficam ocultas
     por CSS, então este código roda mas não tem efeito visível.
     --------------------------------------------------------------------- */

  function setupDiffs(root) {
    root.querySelectorAll('.lzx-diffs').forEach(function (widget) {
      if (widget.dataset.lzxReady) return;
      widget.dataset.lzxReady = '1';

      var track = widget.querySelector('.lzx-diffs__track');
      if (!track) return;

      var total = track.children.length;
      if (total < 2) return;

      var index = 0;

      function go(next) {
        // Circular: passar do último volta ao primeiro.
        index = (next + total) % total;
        track.style.setProperty('--lzx-diff-index', String(index));
      }

      var prev = widget.querySelector('.lzx-diffs__arrow--prev');
      var next = widget.querySelector('.lzx-diffs__arrow--next');
      if (prev) prev.addEventListener('click', function () { go(index - 1); });
      if (next) next.addEventListener('click', function () { go(index + 1); });

      // Arrasto no celular. Só considera gesto horizontal com deslocamento
      // relevante, para não roubar a rolagem vertical da página.
      var startX = null;
      track.addEventListener('touchstart', function (e) {
        startX = e.touches[0].clientX;
      }, { passive: true });

      track.addEventListener('touchend', function (e) {
        if (startX === null) return;
        var delta = e.changedTouches[0].clientX - startX;
        if (Math.abs(delta) > 40) go(delta < 0 ? index + 1 : index - 1);
        startX = null;
      }, { passive: true });
    });
  }

  /* ---------------------------------------------------------------------
     Barra de anúncio (celular)
     No desktop as frases aparecem juntas; o CSS só isola a ativa abaixo do
     breakpoint. A rotação para quando o visitante pede menos animação.
     --------------------------------------------------------------------- */

  function setupAnnounce(root) {
    root.querySelectorAll('.lzx-announce__inner').forEach(function (bar) {
      if (bar.dataset.lzxReady) return;
      bar.dataset.lzxReady = '1';

      var items = bar.querySelectorAll('.lzx-announce__item');
      if (items.length < 2 || REDUCED_MOTION.matches) return;

      var current = 0;
      setInterval(function () {
        items[current].removeAttribute('data-active');
        current = (current + 1) % items.length;
        items[current].setAttribute('data-active', '');
      }, 4000);
    });
  }

  /* ---------------------------------------------------------------------
     Menus: hambúrguer, submenus e busca no celular
     --------------------------------------------------------------------- */

  function closeAllPanels(except) {
    document.querySelectorAll('.lzx-nav__link[aria-expanded="true"]').forEach(function (btn) {
      if (btn === except) return;
      btn.setAttribute('aria-expanded', 'false');
      var panel = btn.nextElementSibling;
      if (panel && panel.classList.contains('lzx-nav__panel')) panel.hidden = true;
    });
  }

  document.addEventListener('click', function (event) {
    var burger = event.target.closest('.sf-burger');
    if (burger) {
      var nav = document.getElementById('lzx-mobile-nav');
      if (nav) {
        var open = nav.hidden;
        nav.hidden = !open;
        burger.setAttribute('aria-expanded', String(open));
      }
      return;
    }

    var toggle = event.target.closest('.sf-search-toggle');
    if (toggle) {
      var header = toggle.closest('.sf-header');
      var search = header && header.querySelector('.sf-header__search');
      if (search) {
        var showing = search.hasAttribute('data-open');
        search.toggleAttribute('data-open', !showing);
        toggle.setAttribute('aria-expanded', String(!showing));
        if (!showing) {
          var input = search.querySelector('input');
          if (input) input.focus();
        }
      }
      return;
    }

    var link = event.target.closest('.lzx-nav__link');
    if (link && link.tagName === 'BUTTON') {
      var panel = link.nextElementSibling;
      if (panel && panel.classList.contains('lzx-nav__panel')) {
        var isOpen = link.getAttribute('aria-expanded') === 'true';
        closeAllPanels(link);
        link.setAttribute('aria-expanded', String(!isOpen));
        panel.hidden = isOpen;
      }
      return;
    }

    // Clique fora fecha os submenus abertos.
    if (!event.target.closest('.lzx-nav__panel')) closeAllPanels(null);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeAllPanels(null);
  });


  /* ---------------------------------------------------------------------
     Galeria do produto
     Todas as fotos já estão no HTML; trocar de imagem é revelar um painel
     e esconder o anterior. Nada é buscado no clique, então a troca é
     imediata mesmo em conexão ruim.
     --------------------------------------------------------------------- */

  document.addEventListener('click', function (event) {
    var thumb = event.target.closest('.sf-pdp__thumb');
    if (!thumb) return;

    var gallery = thumb.closest('.sf-pdp__gallery');
    if (!gallery) return;

    gallery.querySelectorAll('.sf-pdp__thumb').forEach(function (t) {
      t.setAttribute('aria-pressed', String(t === thumb));
    });

    var id = thumb.dataset.lzxMedia;
    gallery.querySelectorAll('[data-lzx-media-panel]').forEach(function (panel) {
      panel.hidden = panel.dataset.lzxMediaPanel !== id;
    });
  });

  /* ---------------------------------------------------------------------
     Ampliação da foto do produto
     Rede é produto técnico: o lojista precisa ver a malha e o nó de perto
     antes de pedir orçamento.
     --------------------------------------------------------------------- */

  function closeZoom() {
    var box = document.getElementById('lzx-zoom');
    if (!box || box.hidden) return;
    box.hidden = true;
    document.body.classList.remove('lzx-no-scroll');
    var opener = document.querySelector('.sf-pdp__zoom:not([hidden])');
    if (opener) opener.focus();
  }

  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-lzx-close-zoom]')) {
      closeZoom();
      return;
    }

    var opener = event.target.closest('.sf-pdp__zoom');
    if (!opener) return;

    var box = document.getElementById('lzx-zoom');
    var target = box && box.querySelector('[data-lzx-zoom-target]');
    if (!box || !target) return;

    target.src = opener.dataset.lzxZoom;
    var img = opener.querySelector('img');
    target.alt = img ? img.alt : '';
    box.hidden = false;
    document.body.classList.add('lzx-no-scroll');
    var close = box.querySelector('.lzx-lightbox__close');
    if (close) close.focus();
  });

  /* ---------------------------------------------------------------------
     Gaveta de filtros (celular)
     --------------------------------------------------------------------- */

  function closeDrawer(drawer) {
    if (!drawer) return;
    drawer.hidden = true;
    document.body.classList.remove('lzx-no-scroll');
    var opener = document.querySelector('[data-lzx-open-drawer="' + drawer.id + '"]');
    if (opener) opener.focus();
  }

  document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-lzx-open-drawer]');
    if (opener) {
      var drawer = document.getElementById(opener.dataset.lzxOpenDrawer);
      if (drawer) {
        drawer.hidden = false;
        document.body.classList.add('lzx-no-scroll');
        var focusable = drawer.querySelector('.lzx-drawer__close');
        if (focusable) focusable.focus();
      }
      return;
    }

    var closer = event.target.closest('[data-lzx-close-drawer]');
    if (closer) closeDrawer(closer.closest('.lzx-drawer'));
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.lzx-drawer:not([hidden])').forEach(closeDrawer);
    closeZoom();
  });

  /* ---------------------------------------------------------------------
     Ordenação
     O <select> submete sozinho ao mudar. O <noscript> do markup mantém um
     botão para quem está sem JavaScript.
     --------------------------------------------------------------------- */

  document.addEventListener('change', function (event) {
    var form = event.target.closest('[data-lzx-autosubmit]');
    if (form) form.submit();
  });


  /* ---------------------------------------------------------------------
     Carrossel das faixas de produto (computador)
     Rola por página inteira, não por card: o visitante vê um conjunto novo
     a cada clique em vez de um card meio cortado.
     --------------------------------------------------------------------- */

  function setupCarousels(root) {
    root.querySelectorAll('[data-lzx-carousel]').forEach(function (widget) {
      if (widget.dataset.lzxReady) return;
      widget.dataset.lzxReady = '1';

      var track = widget.querySelector('.lzx-carousel__track');
      var prev = widget.querySelector('.lzx-carousel__arrow--prev');
      var next = widget.querySelector('.lzx-carousel__arrow--next');
      if (!track || !prev || !next) return;

      function refresh() {
        // 2px de folga: larguras fracionárias impedem que scrollLeft chegue
        // exatamente ao máximo, e sem a folga a seta nunca desapareceria.
        var max = track.scrollWidth - track.clientWidth;
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= max - 2;
      }

      function page(direction) {
        track.scrollBy({ left: direction * track.clientWidth, behavior: 'smooth' });
      }

      prev.addEventListener('click', function () { page(-1); });
      next.addEventListener('click', function () { page(1); });
      track.addEventListener('scroll', refresh, { passive: true });
      window.addEventListener('resize', refresh);
      refresh();
    });
  }

  /* ------------------------------------------------------------------- */

  function init(root) {
    setupDiffs(root || document);
    setupAnnounce(root || document);
    setupCarousels(root || document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  // O editor de temas troca o HTML da seção sem recarregar a página.
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
